<template>
<div>
  <div class="ep-navbar">
    <!-- Logo and page access -->
    <div class="ep-navbar--left">

      <h2 class="ep-navbar--title">
        <router-link class="ep-navbar--link" :to="{ name: 'HomePage'}">
          <img src='../assets/img/logo.png' class="ep-navbar--left--logo" />
        </router-link>
      </h2>
    </div>

    <!-- login and activate buttons -->

    <div class="ep-navbar--right">
      <div class="ep-navbar__topNavbar">
        <div class="ep-navbar__topNavbar--container">
          <!-- twitter -->
          <a class="ep-navbar__topNavbar--media icon-twitter" href="https://twitter.com/SilaeSolutions" target="_blank"></a>
          <!-- linkedIn-->
          <a class="ep-navbar__topNavbar--media" href="https://www.linkedin.com/company/silae/mycompany/" target="_blank">in</a>
        </div>
      </div>

      <div>
        <!-- Page Listing -->
        <ul class='ep-navbar--list'>
          <li class="ep-navbar--list--item">
            <router-link class="ep-navbar--link" :to="{ name: 'HomePage'}">
              {{ $t('navbar.link.welcome') }}
            </router-link>
          </li>
          <li class="ep-navbar--list--item">
            <router-link class="ep-navbar--link" :to="{ name: 'Security'}">
              {{ $t('navbar.link.security') }}
            </router-link>
          </li>
          <li class="ep-navbar--list--item">
            <router-link class="ep-navbar--link" :to="{ name: 'Prices'}">
                {{ $t('navbar.link.prices') }}
            </router-link>
          </li>
        </ul>
        <button class="ep-button ep-navbar--button"
                @click="$router.push({ name: 'Login'})">
          {{ $t('navbar.button.login') }}
        </button>
      </div>

       <!-- small screen display menu button -->
      <button class="ep-button
      ep-button__rnd-responsive
      ep-navbar--left--list-logo"
      @click="showSidebar">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </div>

  <!-- Sidebar mobile -->
    <!--eslint-disable-next-line max-len-->
  <div :class="[sidebarVisible ?  'ep-sidebar' : 'ep-sidebar ep-sidebar--closed']" @click.self="showSidebar">
      <!--eslint-disable-next-line max-len-->
    <div :class="[sidebarVisible ?  'ep-sidebar__panel' : 'ep-sidebar__panel ep-sidebar__panel--closed']" >
        <!-- top part of Sidebar -->
      <div>
        <h2 class="ep-navbar--title" >
          <router-link
          class="ep-navbar--link" :to="{ name: 'HomePage', }"  @click.native="showSidebar">
            <img src='../assets/img/logo.png' class="ep-navbar--left--logo" />
          </router-link>
        </h2>
        <ul>
          <li class="ep-navbar--list--item">
          <!--eslint-disable-next-line max-len-->
            <router-link  @click.native="showSidebar" class="ep-navbar--link" :to="{ name: 'HomePage'}">
              {{ $t('navbar.link.welcome') }}
            </router-link>
          </li>
          <li  class="ep-navbar--list--item">
          <!--eslint-disable-next-line max-len-->
            <router-link @click.native="showSidebar" class="ep-navbar--link" :to="{ name: 'Security'}">
              {{ $t('navbar.link.security') }}
            </router-link>
          </li>
          <li  class="ep-navbar--list--item">
          <!--eslint-disable-next-line max-len-->
          <router-link @click.native="showSidebar" class="ep-navbar--link" :to="{ name: 'Prices'}">
              {{ $t('navbar.link.prices') }}
            </router-link>
          </li>
        </ul>
        <button class="ep-button"
          @click="ButtonEventLogin">
          {{ $t('navbar.button.login') }}
        </button>
      </div>

      <!-- bottom part of Sidebar -->
      <div class="ep-sidebar__panelBottom">
        <div  class="ep-footer--line--network">
           twitter
          <a  class="ep-navbar__topNavbar--media icon-twitter" href="https://twitter.com/SilaeSolutions" target="_blank"></a>
           linkedIn
          <a class="ep-navbar__topNavbar--media" href="https://www.linkedin.com/company/silae/mycompany/" target="_blank">in</a>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import i18n from '../i18n';

export default {
  methods: {
    i18n() {
      return i18n;
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/navbar.vue